/* eslint-disable */
jQuery(function ($) {
	'use strict';

	var form = new CustomPost.LiveForm;

	// Clear selected items of the search field
	$(document).on('click', '.clear-selected', function (e) {
		e.preventDefault();
		$('.search-items select').each(function () {
			$(this).prop('selectedIndex', 0);
		});

		form.refresh();
	});

	// Add active class to labels whose checkbox/radio is checked
	form.on('load refresh', function () {
		$('label :checkbox, label :radio').each(function () {
			$(this).parents('label')[$(this).is(':checked') ? 'addClass' : 'removeClass']('active');
		});
	});

	// Fix for pagination arrows next and prev not remembering current filters after click
	$(document).on('click', '.rw-pagination--item--link', function (e) {
		e.preventDefault();
		if($(this).hasClass('prev')){
			$('.rw-pagination .navigation-p-a .page-numbers.current').prev().trigger('click');
		}else if($(this).hasClass('next')){
			$('.rw-pagination .navigation-p-a .page-numbers.current').next().trigger('click');
		}
	});
	
	// Het aanbod heeft een paginatie met a linkjes
	// Als daarop geklikt word dan word de pagina geheel herladen en worden geselecteerde filters vergeten.
	// Vandaar deze workaround. Alles omzetten naar een span in plaats van een a. 
	// Via javascript zorgen we ervoor dat zodra er op een span geklikt word, de betreffende verborgen a link word aangeklikt via trigger('click') want op een of andere manier werkt het dan wel zonder dat de pagina herladen word
	$(document).on('click', '.custom-pagination .page-numbers', function (e) {
		e.preventDefault();
		$('.rw-pagination a[href="'+$(this).attr('href')+'"]').trigger('click');
	});

	// Scroll to top on page change
	form.on('change:page', function () {
		var to = $('#entity-results').offset().top;
		var from = $(window).scrollTop();

		if (from > to) {
			$('html, body').animate({ scrollTop: to }, 300);
		}
	});

    form.on('updated', function() {
        var reset = $('.clear-selected');
        if (reset.hasClass('is-reset')) {
            reset.removeClass('is-reset');
        } else {
            reset.addClass('d-inline-flex');
        }
    });

    $('.clear-selected').on('click', function () {
        $(this).removeClass('d-inline-flex');
        $(this).addClass('is-reset');
    });

	form.init();

	// Add JS helper class to document body
	$(document.body).addClass('has-js');

});
